module.exports = __webpack_public_path__ + "static/media/sacred-heart.96ca02c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/sacred-heart.jpg
// module id = 632
// module chunks = 0